import React from "react"
import articleSidebars from "stores/articleSidebars"
import { useList } from 'effector-react'
import ArticleSidebar, { IArticleSidebarProps } from "components/ArticleSidebar/ArticleSidebar"
import useLocationChange from "hooks/useLocationChange"

const ArticleSidebars = () => {
    useLocationChange(articleSidebars.clear)

    async function handleClose(props: IArticleSidebarProps) {
        if (typeof props.onClose === "function") {
            props.onClose()
        }
        articleSidebars.hide(props)
    }

    return (
        <>
            {useList(articleSidebars.list, (props: IArticleSidebarProps, idx) => (
                <ArticleSidebar
                    key={idx}
                    {...props}
                    onClose={() => handleClose(props)}
                />
            ))}
        </>
    )
}

export default ArticleSidebars
